import type { ReactNode } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { FaqItem, Link, BasicUspItem } from '~/lib/data-contract/auto-generated/api-model';
import { Product, Image } from '~/lib/data-contract/salesforce';

export type SummaryProduct = {
    brand: string;
    name: string;
    image: Image;
    quantity: number;
    price: string;
    description: string;
};

export type SummaryListProps = {
    title?: string;
    products: Product[];
    hasBorder?: boolean;
};

export type USPProps = {
    usps: BasicUspItem[];
};

export type FaqProps = {
    title?: string;
    faqs?: FaqItem[];
    className?: string;
};

export type SummaryPrice = {
    label: string;
    value?: string | number;
    info?: string;
    type: 'default' | 'discount';
};
export type PriceProps = {
    prices?: SummaryPrice[];
    link?: Link;
    onCtaHandler?: () => void;
    onSignupIntent?: (payload: Record<string, string>) => void;
    signupName?: string;
    disabledButton?: boolean;
    signupLabel?: string | '';
    ctaLabel?: string;
    fullMode?: boolean;
    isRegistered?: boolean;
    isLoading?: boolean;
    freeShipping?: boolean;
    amountToFreeShipping?: string;
    membership: boolean;
    setMembership: (membership: boolean) => void;
    /** Rendered after price/membership content and before the CTA button */
    children?: ReactNode;
};

export type PromoCode = {
    name: string;
    code: string;
};
export type PromoCodeProps = {
    title: string;
    titleAddon?: string;
    text?: string;
    name: string;
    onSubmit?: SubmitHandler<Record<string, string>>;
    onRemovePromoCode?: (PromoCode: PromoCode) => void;
    submitLabel: string;
    activePromoCodes?: PromoCode[];
};

export enum GiftCertificateFormFields {
    Card = 'card',
    Cvc = 'cvc',
}

export type GiftCode = {
    name: string;
    id: string;
};

export type GiftCertificateFormData = {
    [GiftCertificateFormFields.Card]: string;
    [GiftCertificateFormFields.Cvc]?: string;
};

export type GiftCertificateProps = {
    title: string;
    text?: string;
    name: string;
    onSubmit: SubmitHandler<GiftCertificateFormData>;
    onRemove?: (code: GiftCode) => void;
    submitLabel: string;
    activeCodes?: GiftCode[];
};

export type SummaryProps = {
    handlers?: {
        onCta?: () => void;
        onAddPromoCode?: (payload: Record<string, string>) => void;
        onRemovePromoCode?: (PromoCode: PromoCode) => void;
        onSignupIntent?: (user: Record<string, string>) => void;
    };
    PromoSection?: PromoCodeProps;
    priceSection?: PriceProps;
    faqSection?: FaqProps;
    uspSection?: USPProps;
    productSection?: SummaryListProps;
};

export type TFormReset = {
    reset: () => void;
};
